import React, {useEffect, useRef, useState} from 'react'
import {Col, Form, Input, Row, Select, Space, Typography} from 'antd'
import FormErrorMessage from '../base/FormErrorMessage'
import {validateMessages} from '../../app/util'
import SubjectSelect from './SubjectSelect'
import moment from 'moment'
import NewPiecesFormButton from './NewPiecesFormButton'
import {loadForm} from '../../app/cacheUtil'
import {RequiredTitle} from './common'
import {is_admin_user} from "../../app/role";

const {Title, Text} = Typography
const {Option} = Select

export default (props) => {
    const [validateError, setValidateError] = useState([])
    const [numberOfDays, setNumberOfDays] = useState()
    const formRef = useRef(null)

    const onFinishFailed = ({values, errorFields, outOfDate}) => {
        setValidateError(errorFields)
        window.scrollTo(0, 0)
        window.scrollTop = 0
    }

    const yearOptions = []
    for (let year = moment().year(); year >= 1970; year--) {
        yearOptions.push({
            label: String(year),
            value: String(year)
        })
    }

    const getMonthDay = (year, month) => {
        return moment(`${year}-${month}`, 'YYYY-MM').daysInMonth()
    }

    const onYearAndMonthChange = () => {
        if (formRef.current == null) return
        const year = formRef.current.getFieldValue('year')
        if (year === undefined) return
        const month = formRef.current.getFieldValue('month')
        if (month === undefined) return
        setNumberOfDays(getMonthDay(year, month))
    }

    useEffect(() => {
        const cache = loadForm(props.formId)
        if (cache) {
            formRef.current?.setFieldsValue(cache)
        }
    }, [])

    return (
        <>
            <FormErrorMessage error={validateError}/>
            <Form
                colon={false}
                ref={formRef}
                labelAlign='left'
                layout={'vertical'}
                onFinish={props.onFinish}
                validateMessages={validateMessages}
                onFinishFailed={onFinishFailed}
                style={{
                    marginTop: '16px'
                }}
            >
                <Row
                    style={{
                        paddingLeft: '6vw',
                        paddingRight: '3vw',
                        maxWidth: 1280,
                        height: '100%',
                        flexDirection: 'row'
                    }}
                >
                    <Col xs={24} sm={24} md={12} style={{marginTop: 32, paddingLeft: 32, paddingRight: 32}}>
                        <Space direction={'vertical'} style={{width: '100%'}}>
                            <Form.Item
                                label={RequiredTitle('Category')}
                                name='medium_type_str'
                                rules={[
                                    {
                                        required: !is_admin_user(props)
                                    }
                                ]}
                            >
                                <Select mode='multiple' placeholder='Please select'>
                                    <Option value='painting'>Painting</Option>
                                    <Option value='drawing'>Drawing</Option>
                                    <Option value='sculpture'>Sculpture</Option>
                                    <Option value='collage'>Collage</Option>
                                    <Option value='mixed-media'>Mixed Media</Option>
                                    <Option value='installation-digital'>Installation Digital</Option>
                                    <Option value='others'>Others</Option>
                                </Select>
                            </Form.Item>
                            <Form.Item
                                name='material_type_str'
                                label={RequiredTitle('Mediums & Materials')}
                                rules={[
                                    {
                                        required: !is_admin_user(props),
                                        type: 'string'
                                    }
                                ]}
                            >
                                <Input placeholder='for example, Oil on Canvas'/>
                            </Form.Item>
                            <Form.Item
                                name='year'
                                label={RequiredTitle('Year')}
                                rules={[
                                    {
                                        required: true
                                    }
                                ]}
                            >
                                <Select
                                    placeholder={
                                        <>
                                            <Text type='secondary'>Year</Text>
                                            <Text type='danger'>*</Text>
                                        </>
                                    }
                                    onChange={onYearAndMonthChange}
                                    options={yearOptions}
                                />
                            </Form.Item>
                            <Form.Item
                                name='content_info_str'
                                label='Subject'
                                rules={[
                                    {
                                        required: false
                                    }
                                ]}
                            >
                                <SubjectSelect mode='multiple' placeholder='Please select' style={{width: '100%'}}/>
                            </Form.Item>
                        </Space>
                    </Col>
                    <Col xs={24} sm={24} md={12} style={{marginTop: 32, paddingLeft: 32, paddingRight: 32}}>
                        <Space direction={'vertical'} style={{width: '100%'}}>
                            <Form.Item
                                name='label_str'
                                label='Tags (Comma separated)'
                                style={{width: '100%'}}
                                rules={[
                                    {
                                        min: 1,
                                        max: 100,
                                        type: 'string'
                                    }
                                ]}
                            >
                                <Input/>
                            </Form.Item>
                            <Form.Item
                                label='Style'
                                name='style_type_str'
                                rules={[
                                    {
                                        required: !is_admin_user(props)
                                    }
                                ]}
                            >
                                <Select mode='multiple' placeholder='Please select'>
                                    <Option value='fine-art'>Fine Art</Option>
                                    <Option value='abstract'>Abstract</Option>
                                    <Option value='modern'>Modern</Option>
                                    <Option value='street-art'>Street Art</Option>
                                    <Option value='pop-art'>Pop Art</Option>
                                    <Option value='mural-art'>Mural Art</Option>
                                    <Option value='public-art'>Public Art</Option>
                                    <Option value='illustration'>Illustration</Option>
                                    <Option value='others'>Others</Option>
                                </Select>
                            </Form.Item>
                        </Space>
                    </Col>
                    <NewPiecesFormButton {...props} stepperCount={1}/>
                </Row>
            </Form>
        </>
    )
}
